import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      class: "booking-dialog-open-btn",
      color: "primary",
      variant: "flat",
      onClick: $setup.openBookingDialogAndPrefillData
    }, {
      default: _withCtx(() => [
        _createTextVNode("Foglalás létrehozása")
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: $setup.showCreateBookingDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.showCreateBookingDialog) = $event)),
      width: "1200",
      height: "900",
      persistent: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "new-item-card",
          title: `Foglalás létrehozása`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_combobox, {
                          modelValue: $setup.newItem.accommodation,
                          "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event: any) => (($setup.newItem.accommodation) = $event)),
                            $setup.handleAccommodationsComboboxChange
                          ],
                          label: "Szálláshely",
                          items: $setup.allAccommodations.map((accommodation)=> accommodation.name),
                          loading: $setup.accommodationsLoading,
                          dense: ""
                        }, null, 8, ["modelValue", "items", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_combobox, {
                          modelValue: $setup.newItem.product,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => (($setup.newItem.product) = $event)),
                            $setup.handleProductsComboboxChange
                          ],
                          label: "Termék",
                          items: $setup.productsForSelectedAccommodation.map((product)=> product.name),
                          dense: ""
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.grossPricePerPersonPerNight,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.newItem.grossPricePerPersonPerNight) = $event)),
                          label: "Bekerülési ár /fő/éj",
                          type: "text",
                          inputmode: "numeric",
                          pattern: "[0-9]*",
                          dense: "",
                          onBlur: $setup.sanitizeGrossPrice
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.retailPrice,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.newItem.retailPrice) = $event)),
                          label: "Kiajánlott ár /fő/éj",
                          type: "text",
                          inputmode: "numeric",
                          pattern: "[0-9]*",
                          dense: "",
                          onBlur: $setup.sanitizeRetailPrice
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.startDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.newItem.startDate) = $event)),
                          label: "Érkezés",
                          type: "date",
                          dense: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.endDate,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.newItem.endDate) = $event)),
                          label: "Távozás",
                          type: "date",
                          dense: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      md: "1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.numberOfPeople,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.newItem.numberOfPeople) = $event)),
                          modelModifiers: { number: true },
                          label: "Létszám",
                          type: "number",
                          dense: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.city,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.newItem.city) = $event)),
                          label: "Város",
                          dense: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: $setup.newItem.address,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.newItem.address) = $event)),
                          label: "Cím",
                          dense: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_tooltip, {
                      disabled: $setup.isNewItemValid,
                      text: $setup.addItemTooltip
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _mergeProps({ class: "w-100" }, props), [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "flat",
                            block: "",
                            disabled: !$setup.isNewItemValid,
                            onClick: $setup.addItem
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hozzáadás")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ], 16)
                      ]),
                      _: 1
                    }, 8, ["disabled", "text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_data_table, {
              items: $setup.indexedItems,
              headers: $setup.headers,
              "hide-default-footer": true,
              "item-key": "_localId",
              hover: ""
            }, {
              top: _withCtx(() => [
                _createVNode(_component_v_toolbar, { height: "56" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`Foglalás elemei`))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              "item.numberOfPeople": _withCtx(({ item }) => [
                _createVNode(_component_v_text_field, {
                  modelValue: item.numberOfPeople,
                  "onUpdate:modelValue": ($event: any) => ((item.numberOfPeople) = $event),
                  type: "number",
                  dense: "",
                  "hide-details": "",
                  style: {"max-width":"80px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              "item.index": _withCtx(({ item }) => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-delete-forever-outline",
                  onClick: () => $setup.removeItem(item._localId)
                }, null, 8, ["onClick"])
              ]),
              bottom: _withCtx(() => []),
              _: 1
            }, 8, ["items"]),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: $setup.cancellationPolicy,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.cancellationPolicy) = $event)),
                  label: "Lemondási feltételek *",
                  variant: "outlined",
                  rows: "4",
                  "error-messages": $setup.cancellationPolicyError,
                  hint: "Pl. Ingyenes lemondás 14 nappal érkezés előtt. 7–14 nap között: 30% lemondási díj.",
                  "persistent-hint": ""
                }, null, 8, ["modelValue", "error-messages"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  text: "Foglalás létrehozása",
                  disabled: $setup.indexedItems.length === 0 || !$setup.cancellationPolicy.trim(),
                  onClick: $setup.createBooking
                }, null, 8, ["disabled"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "secondary",
                  variant: "outlined",
                  text: "Vissza",
                  onClick: $setup.closeBookingDialog
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}